import {Card, CardActionArea, CardMedia, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {downloadImage} from "../../helpers/utils";
import React, {useEffect, useMemo, useState} from "react";

import {parseValue} from "../../hooks";

import {useFetch} from "../../helpers/hooks";
import {Endpoint} from "../../constants/enums";

import {LinkOutlined, PlaceOutlined} from "@material-ui/icons";

const useStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 500,
    height: 'auto',
    border: '1px solid #D4D4D4',
    backgroundColor: '#F9F9F9',
    borderRadius:'0 0 10px 10px',
    boxShadow: 'none'
  },
  media: {
    height: 320,
    backgroundPosition: 'top',
    backgroundSize: 'auto 320px'

  },
  content: {
    backgroundColor: '#F9F9F9',
  },

  borderLoc: {
    border: '0px solid #F9F9F9',
    borderBottom: '2px solid #F9F9F9'
  },

  borderArea: {
    border: '2px solid #F9F9F9'
  }
});

const ExtraInformationItem = ({text, icon, href, focusClass}) => {
    const InfoIcon = icon;
    const [focus, setFocus] = useState(false);

    const onFocus = function(){
      setFocus(!focus);
    };

    const onBlur = function(){
      setFocus(false);
    };


  return <>
    {(1==1 || (text && text !== '')) &&
      <>
        <Grid item xs={2}>
          <InfoIcon style={{verticalAlign:'bottom',visibility:(text && text !== '')?'visible':'hidden' }}/>
        </Grid>
        <Grid item xs={10} className={focus?focusClass:''} onBlur={onBlur} onClick={onFocus} >
          {href ? <a href={href} rel={'noreferrer'} target={'_blank'}>
              <Typography variant={'caption'}>{text}</Typography>
            </a>
            : <Typography variant={'caption'}>{text}</Typography>
          }
        </Grid>
      </>
    }
  </>
}

const ExtraInformation = ({place, source}) => {
  const classes = useStyles();

  return <Grid container spacing={2} style={{marginTop: 0}} direction={'row'} alignItems={'center'}
               alignContent={'center'}>
    <ExtraInformationItem text={place} icon={PlaceOutlined} key={1} focusClass={classes.borderArea} />
    <ExtraInformationItem text={source} icon={LinkOutlined} key={2} focusClass={classes.borderLoc} />
  </Grid>
}

const ExhibitCard = (props) => {

  const classes = useStyles();

  const {exhibit,fullDescription,onclick} = props
  const url = `${Endpoint.containers}/${exhibit.uuid}`
  const [, result, ] = useFetch(url);
  const [thumbnail, setThumbnail] = useState(null)
  const [flipped,setFlipped] = useState(null)
  const [coverImage,setCoverImage] = useState(thumbnail)

  useEffect(()=>{
    if (thumbnail)
      setCoverImage(thumbnail)
  },[thumbnail])

  const toggleImage = () =>{
    if (flipped)
      if (coverImage === thumbnail)
        setCoverImage(flipped)
      else setCoverImage(thumbnail)
    return true
  }



  const description = useMemo(() => {
    if (!result) return
    return parseValue('property:description', result?.properties)
  }, [result])

  const longDescription = useMemo(()=>{
    if (!result) return
    return parseValue('paragraph',result?.properties)
  },[result])

  const place = useMemo(() => {
    if (!result) return
    return parseValue('p:toposxrisis', result?.properties)
  }, [result])

   const backgroundCol ={
        backgroundColor: "rgb(255, 255, 255)"
   }

  const source = useMemo(() => {
    if (!result) return
    return parseValue('p:enotita-katigoria', result?.properties)
  }, [result])

  useMemo(() => {
    const mainImage = (result && result.datastreams && result.datastreams.length>0)?result.datastreams[0]:null
    const flippedImage = (result && result.datastreams && result.datastreams.length>1)?result.datastreams[1]:null
    if (!result || !mainImage) return null

    downloadImage(mainImage?.uuid, setThumbnail)
    if (flippedImage) {
      downloadImage(flippedImage?.uuid, setFlipped)
    }
  }, [result])

  return <Card className={classes.root} style={{borderRadius: "0 0 0 0"}}>
    <CardActionArea>
      <CardMedia
        onClick={()=>{onclick(result)}}
        className={classes.media}
        image={coverImage!=null?coverImage:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8+R8AAvcB+vBGZskAAAAASUVORK5CYII='}
        title={result?.label}
      />
    </CardActionArea>
    <CardContent className={classes.content}>
      <Grid container direction={'column'}>
        <Grid item>
          <Typography gutterBottom variant="h6" style={{marginTop: 24, color: "#000000"}} component="h6" align={'center'}>
             <a href="#" style={{color: "#000000"}} onClick={()=>{onclick(result)}}>{result?.label}</a>
          </Typography>
        </Grid>
        <Grid item>
          <ExtraInformation place={place} source={source}/>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}

export default ExhibitCard